<template>
  <v-main style="background-color: #7260FF">
    <AppBar title="샘플 페이지" hide-background>
      <!-- click 이벤트를 구분 하고 싶을때 slot으로 추가 후 컨트롤 -->
<!--      <template #start>-->
<!--        <v-btn icon plain :ripple="false">-->
<!--          <IconBack />-->
<!--        </v-btn>-->
<!--      </template>-->
    </AppBar>
    <v-layout fill-height column>

      <v-container flex-fill fluid>
        <div class="d-flex fill-height align-center justify-center">
          full page 중 넓은 영역 차지하는 부분
        </div>
      </v-container>

      <v-container fluid>
        full page 중 넓은 영역 차지하는 부분
      </v-container>

      <div class="footer-btns">
        <BlackBtn str="확인" />
      </div>
    </v-layout>
  </v-main>
</template>

<script>
// import store from '@/store'
// import IconBack from'../components/icons/Back'
import BlackBtn from '../components/btns/BlackBtn'

export default {
  components: {
    // IconBack,
    BlackBtn
  },
  mixins: [],
  props: {},
  data: () => ({}),
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods:{}
}
</script>

<style lang="scss" scoped>
</style>